import confetti from "canvas-confetti";
import { toast } from "sonner";

const RIQ_COLORS = ["#6E3FFC", "#8B6DFF", "#F5A623", "#22B573", "#FF6B6B"];

export function burstConfetti() {
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
  const opts = { spread: 70, startVelocity: 45, colors: RIQ_COLORS, zIndex: 9999 };
  confetti({ ...opts, particleCount: 80, origin: { x: 0.5, y: 0.7 } });
  setTimeout(() => confetti({ ...opts, particleCount: 50, angle: 60, origin: { x: 0, y: 0.8 } }), 150);
  setTimeout(() => confetti({ ...opts, particleCount: 50, angle: 120, origin: { x: 1, y: 0.8 } }), 300);
}

// unlocked: [{ id, title, icon, bonus, kind }]
export function celebrateUnlocks(unlocked) {
  if (!unlocked || !unlocked.length) return;
  burstConfetti();
  unlocked.forEach((u, i) => {
    setTimeout(() => {
      const label = u.kind === "streak" ? "🔥 Streak milestone!" : "🏆 Achievement unlocked!";
      toast.success(`${label} ${u.title}`, {
        description: u.bonus > 0 ? `+${u.bonus} bonus Moolas added to your balance` : undefined,
        duration: 5000,
      });
    }, i * 500);
  });
}
